import { useMemo } from "react";
import { IHeaderTable } from "types/global";

export const useDeliveryTripItemListHeader = (
  disabled: boolean,
  status?: string,
) => {
  return useMemo<IHeaderTable[]>(() => {
    const defaultHeaders: IHeaderTable[] = [
      { thaiLabel: "", label: "No.", width: 50 },
      {
        thaiLabel: "เลขที่เอกสาร",
        label: "Delivery Trip Document ID",
        width: 150,
        align: "left",
      },
      { thaiLabel: "Job No.", label: "Job No.", width: 100, align: "left" },
      {
        thaiLabel: "วันที่ออกเอกสาร",
        label: "Issue Date",
        width: 150,
        align: "left",
      },
      {
        thaiLabel: "ทะเบียนรถ",
        label: "License Plate",
        width: 100,
        align: "left",
      },
      {
        thaiLabel: "ประเภทรถ",
        label: "Vehicle Type",
        width: 100,
        align: "left",
      },
      {
        // 86d488a5h — read-only billing reference, right-aligned like the
        // other numeric columns. Everything below reads headers.length, so
        // adding here shifts every hard-coded header index by one.
        thaiLabel: "ราคาน้ำมัน",
        label: "Fuel Price",
        width: 100,
        align: "right",
      },
      {
        thaiLabel: "รหัสสินค้า",
        label: "Item Unique ID",
        width: 100,
        align: "left",
      },
      {
        thaiLabel: "ชื่อสินค้า",
        label: "Item Name",
        width: 150,
        align: "left",
      },
      {
        thaiLabel: "จำนวนเงิน",
        label: "Pre Vat Amount",
        width: 150,
        align: "right",
        required: true,
      },
    ];

    const showAction =
      [null, undefined, "", "draft", "cancelled", "wait_payment"].includes(
        status as any,
      ) && !disabled;

    return showAction
      ? [
          ...defaultHeaders,
          {
            label: "",
            thaiLabel: "",
            width: 20,
          },
        ]
      : defaultHeaders;
  }, [disabled, status]);
};
